import styled from 'styled-components';

export const ImgDescCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.$gap || '16px'};
  margin: 0 auto;
`;

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  padding: var(--home-block-padding) 0;
  gap: 16px;
`;

export const JetImg = styled.img`
  width: auto;
  flex: 0 0 ${(props) => (props.$hasRightSlot ? '33.3333%' : '50%')};
  object-fit: cover;
  max-height: 700px;
  order: ${(props) => (props.$isLeft ? 1 : 2)};
  transform: ${(props) => (props.$flip ? 'scaleX(-1)' : 'none')};
`;

export const DescBox = styled.div`
  width: 100%;
  flex: 0 0 ${(props) => (props.$hasRightSlot ? '33.3333%' : '50%')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  background: #f4f6fc;
  padding: 24px;
  border-radius: 2px;
  order: ${(props) => (props.$isLeft ? 2 : 1)};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const Title = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

export const DescBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
`;

export const Desc = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: #424748;
`;

export const RightSlot = styled.div`
  width: auto;
  flex: 0 0 33.3333%;
  order: 3;
`;
